<template>
  <div class="questions-list">
    <h3 class="list-title"> {{$t('exam.questions')}} </h3>

    <transition-group
        name="marker-list"
        tag="div"
        class="markers-container"
    >
      <template v-if="markers.length">
        <div
            v-for="(marker, idx) in markers"
            :key="marker.id"
            class="question-item"
            :class="markerDragState.draggedMarkerId===marker.id?'isDraggingNow':null"
        >
          <div class="question-info">
            <div>
              <div class="question-title"> {{$t('exam.question')}} {{ idx + 1 }}</div>
              <div class="question-meta">
                {{ formatTime(marker.time) }} - {{ $t(`general.${getTypeLabel(marker.type)}`)  }}
              </div>
            </div>
          </div>
          <div class="question-actions">
            <button type="button" class="update-btn" @click.prevent="updateMarker(marker)">
                {{$t('general.update')}}
            </button>
            <button type="button" class="delete-btn" @click.prevent="deleteMarker(marker)" :title="$t('general.delete')">
              <i class="uil-trash-alt"></i>
            </button>
          </div>
        </div>
      </template>
    </transition-group>

    <template v-if="!markers.length">
      <div class="empty-state-message">
        {{$t('general.no_added_question')}}
      </div>
    </template>

  </div>
</template>

<script>
import {confirmDialogDelete} from "@/utils/confirmDialog";
export default {
  name: 'QuestionsList',
  data() {
    return {
      markers: [],
    };
  },
  computed: {
    markerTypes() {
      return this.$store.getters.markerTypes;
    },
    markerDragState() {
      return this.$store.getters.markerDragState
    },
    isMarkerDragging() {
      const isDragging = this.$store.getters.isMarkerDragging
      if (!isDragging) {
        this.markers = [...this.$store.getters.markers].sort((a, b) => {
          const timeA = typeof a.time === 'number' ? a.time : 0;
          const timeB = typeof b.time === 'number' ? b.time : 0;
          return timeA - timeB;
        });
      }
      return isDragging;
    }
  },
  watch: {
    // liste sıralaması için marker ı izle
    isMarkerDragging: {
      handler(isDragging, wasDragging) {
        // Drag bittiğinde sıralamayı güncelle
        if (wasDragging && !isDragging) {
          this.$forceUpdate();
        }
      },
      immediate: true
    }
  },

  methods: {
    formatTime(time) {

      // time_in_video string formatı varsa onu kullan (HH:MM:SS)
      if (typeof time === 'string' && time.includes(':')) {
        // HH:MM:SS formatını MM:SS formatına çevir
        const parts = time.split(':');
        if (parts.length === 3) {
          const hours = parseInt(parts[0]);
          const minutes = parseInt(parts[1]);
          const seconds = parseInt(parts[2]);
          const totalMinutes = hours * 60 + minutes;
          return `${totalMinutes}:${seconds.toString().padStart(2, '0')}`;
        }
        return time;
      }

      // time sayısal ise, MM:SS formatına çevir
      if (typeof time === 'number') {
        const min = Math.floor(time / 60);
        const sec = Math.floor(time % 60);
        return `${min}:${sec.toString().padStart(2, '0')}`;
      }

      return '0:00';
    },
    getTypeLabel(type) {
      const found = this.markerTypes.find(t => t.typeId === type);
      return found ? found.label : type;
    },
    updateMarker(marker) {
      // Marker'ın type ID'sine göre modal aç (4 çeşit modal olacak)
      const markerType = this.markerTypes.find(t => t.typeId === marker.type);

      if (markerType) {
        // Store'a modal açma verilerini gönder (güncelleme modu için)
        this.$store.dispatch('openModal', {
          ...marker,
          typeId: marker.type,
          time_in_video: marker.time_in_video,
          time: marker.time,
          isUpdateMode: true // Güncelleme modu olduğunu belirt
        });
      } else {
        console.warn('Marker type not found:', marker.type);
      }
    },
    async deleteMarker(marker) {
      const isConfirmed = await confirmDialogDelete({ context: this });

      if (isConfirmed) {
        // Store'dan marker'ı sil
        await this.$store.dispatch('removeMarker', marker.id);
      }
    }
  }
}
</script>

<style scoped>
.questions-list {
  background: #fff;
  border: 1px solid #e1e5e9;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 16px 12px;
  min-width: 320px;
  max-width: 400px;
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 100;
  max-height: 500px;
  overflow-y: auto;
}

.list-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  position: sticky;
  top: 0;
  background: #fff;
  padding: 0 0 12px 0;
  z-index: 10;
  color: #2c3e50;
  border-bottom: 2px solid #f8f9fa;
}

.markers-container {
  position: relative;
}

.question-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #f8fafd 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  transition: all 0.2s ease;
}

.question-item:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Dragging animation  */
.question-item.isDraggingNow {
  background: linear-gradient(135deg, #e0f2fe 0%, #b3e5fc 100%);
  border-color: #23ade5;
  box-shadow: 0 4px 12px rgba(35, 173, 229, 0.2);
}



.question-info {
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 12px;
}

.question-title {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
  margin-bottom: 2px;
}

.question-meta {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.question-actions {
  display: flex;
  align-items: center;
}

.update-btn {
  background: linear-gradient(135deg, #23ade5 0%, #1e88e5 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(35, 173, 229, 0.2);
}

.update-btn:hover {
  background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(35, 173, 229, 0.3);
}

.update-icon {
  font-size: 16px;
  margin-right: 6px;
}

.delete-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-left: 8px;
  width: 32px;
  height: 32px;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);
}

.delete-btn:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3);
}

.delete-btn i {
  font-size: 14px;
}

/* Transition Group Animations */
.marker-list-enter-active,
.marker-list-leave-active {
  transition: all 0.5s ease;
}

.marker-list-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}

.marker-list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.marker-list-move {
  transition: transform 0.5s ease;
}

/* Smooth position changes for reordering */
.marker-list-move-active {
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Enhanced hover effects during transitions */
.question-item.marker-list-move-active {
  z-index: 1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Scrollbar styling */
.questions-list::-webkit-scrollbar {
  width: 8px;
}

.questions-list::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 4px;
  margin: 4px 0;
}

.questions-list::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.questions-list::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
}
</style> 